import { GeneralPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const inventorySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "General", permission: GeneralPermissions.OTHER },
    path: "inventory-management/general",
    lazy: async () => {
      const { InventoryManagementGeneralSettingsPage } =
        await import("../../../../setting/inventory-management/general-settings");
      return { Component: InventoryManagementGeneralSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Purchase orders");
      },
      permission: GeneralPermissions.OTHER,
    },
    path: "inventory-management/purchase-orders",
    lazy: async () => {
      const { PurchaseOrderSettingsPage } =
        await import("../../../../setting/inventory-management/purchase-order-settings");
      return { Component: PurchaseOrderSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("QuickBooks Online");
      },
      permission: GeneralPermissions.OTHER,
    },
    path: "inventory-management/quickbooks",
    children: [
      {
        index: true,
        lazy: async () => {
          const { QuickBooksIntegrationSettingsPage } =
            await import("../../../../setting/inventory-management/quickbooks-integration-settings");
          return { Component: QuickBooksIntegrationSettingsPage };
        },
      },
      {
        handle: {
          get breadcrumb() {
            return t("{{integrationName}} account mappings", {
              integrationName: "QuickBooks",
            });
          },
          permission: GeneralPermissions.OTHER,
        },
        path: "account-mapping",
        lazy: async () => {
          const { QuickBooksAccountMappingPage } =
            await import("../../../../setting/inventory-management/quickbooks-account-mapping");
          return { Component: QuickBooksAccountMappingPage };
        },
      },
    ],
  },
];
